export enum RoomDefaultLabel {
  NoPrice = '--',
  NoAvailability = 'NO AVAILABILITY',
}

export enum RoomTemplateImage {
  AvailproBookingEnginesPreview = 'Availpro-BookingEngines-Preview',
  BookingEngineCarousel = 'BookingEngine-Carousel',
  BookingEngineDetails = 'BookingEngine-Details',
  BookingEngineHotelThumbnail = 'BookingEngine-HotelThumbnail',
  BookingEngineResultThumbnail = 'BookingEngine-ResultThumbnail',
  BookingEngineWide = 'BookingEngine-Wide',
  ConfirmationImageHotel = 'Confirmation_Image_Hotel',
  ConfirmationImageHotel2x = 'Confirmation_Image_Hotel@2x',
  Display = 'Display',
  Large = 'Large',
  Medium = 'Medium',
  Original = 'Original',
  Small = 'Small',
  SmartGalleryPreview = 'Smart_Gallery_Preview',
  SmartImageZoom = 'Smart_Image_Zoom',
  SmartPackagePrincipal = 'Smart_Package_Principal',
  SmartRoomPrincipal = 'Smart_Room_Principal',
  TouchImageExtra = 'Touch_Image_Extra',
  TouchImageExtra2x = 'Touch_Image_Extra@2x',
  TouchImageGallery = 'Touch_Image_Gallery',
  TouchImageGallery2x = 'Touch_Image_Gallery@2x',
  TouchImageHotel = 'Touch_Image_Hotel',
  TouchImageHotel2x = 'Touch_Image_Hotel@2x',
  TouchImageRate = 'Touch_Image_Rate',
  TouchImageRate2x = 'Touch_Image_Rate@2x',
  TouchImageRoom = 'Touch_Image_Room',
  TouchImageRoom2x = 'Touch_Image_Room@2x',
  TouchImageRoomRate = 'Touch_Image_RoomRate',
  TouchImageRoomRate2x = 'Touch_Image_RoomRate@2x',
  UserPictureDetails = 'UserPicture-Details',
  UserPictureThumbnail = 'UserPicture-Thumbnail',
  XLarge = 'XLarge',
}

export enum RoomServicesType {
  General = 'General',
  Bathroom = 'Bathroom',
  Appliances = 'Appliances',
}

export enum RoomSummaryType {
  Html = 'Html',
  PlainText = 'PlainText',
}

export interface RoomOccupancy {
  occupancyId: number;
  isDefault: boolean;
  definition: RoomOccupancyDefinition;
}

export interface RoomOccupancyDefinition {
  text: string;
  value: {
    isDetailed: boolean,
    personCount: number,
    adultCount: number,
    childCount: number,
    infantCount: number,
  };
}

export interface RoomMetadata<T> {
  text: string;
  value: T;
}

export interface RoomImage {
  templates: RoomImageMetadata[];
  sortOrder: number;
}

export interface RoomImageMetadata {
  name: string;
  url: string;
}

export interface RoomServiceMetadata {
  category: RoomMetadata<RoomServicesType>;
  amenities: Array<RoomMetadata<string>>;
}

export interface RoomDescriptionBedding {
  beds: RoomBed[];
  singleBedCount: number;
  doubleBedCount: number;
  sofaCount: number;
}

export interface RoomBed {
  type: RoomMetadata<string>;
  count: number;
  twoPersonConvertible: boolean;
}
